document.addEventListener('DOMContentLoaded', () => {

const addBtn =
document.getElementById(
'add-text-layer'
);

const input = document.getElementById('embroideryTextInput');

const container = document.getElementById('textLayerContainer');

if (!container) return;
function getCurrentApplique(){

return document.getElementById(
"appliqueType"
)?.value || "";

}

function createTextLayer(textValue = null){

const text =
  textValue ||
  input?.value ||
  `Text Layer ${document.querySelectorAll('.embroidery-text-layer').length + 1}`;

const layer = document.createElement('div');

layer.className = 'embroidery-text-layer';

const textContainer =
document.createElement("div");

textContainer.className =
"text-content";

text.split("").forEach(letter=>{

const span =
document.createElement("span");

span.className =
"curve-letter";

span.setAttribute(
"data-letter",
letter
);

span.innerText =
letter;

textContainer.appendChild(span);

});

layer.appendChild(textContainer);

const textHandle =
document.createElement("div");

textHandle.className =
"text-resize-handle";

layer.appendChild(textHandle);

const count =
document.querySelectorAll('.embroidery-text-layer').length;

layer.style.left =
(50 + count * 20) + 'px';

layer.style.top =
(50 + count * 20) + 'px';

layer.style.fontSize = '32px';

layer.style.color = '#000';

layer.dataset.layerId = Date.now();

applyCurvature(layer, 0);
container.appendChild(layer);
layer.addEventListener("click", () => {

  document
    .querySelectorAll(
      ".embroidery-text-layer,.embroidery-image-layer"
    )
    .forEach(el =>
      el.classList.remove("active-layer")
    );

  layer.classList.add("active-layer");

  window.selectedEmbroideryLayer = layer;

});

}

window.createEmbroideryTextLayer = createTextLayer;

addBtn?.addEventListener('click', () => {

if (!input.value.trim()) return;

createTextLayer(input.value);

});

});